// @flow

import * as React from 'react';
import ReactDOM from 'react-dom';
import Config from '@insolus/config';
import { BrowserRouter } from '@insolus/react-router';
import { I18nProvider } from '@insolus/react-i18n';
import I18n from '@insolus/i18n';
import { Spinner } from '@insolus/ui-kit';
import globalSetup from 'config/setup';

type ThemeBootstrap = () => React.ComponentType<*>;

export default (themeBootstrap: ThemeBootstrap) => {
    globalSetup();

    const RootComponent = themeBootstrap();
    const AppWrapper = (): React.Node => (
        <I18nProvider i18n={I18n}>
            <BrowserRouter basename={Config.get('location.base')}>
                <React.Suspense fallback={<Spinner type="dots" />}>
                    <RootComponent />
                </React.Suspense>
            </BrowserRouter>
        </I18nProvider>
    );

    const $$app = document.getElementById('app');
    if (!$$app) {
        throw new Error(`Le point de montage React n'a pas été trouvé (#app).`);
    }

    ReactDOM.render(<AppWrapper />, $$app);
};
